/**
 *  web-auth SDK 를 Raw API 형태로 사용 할 수 있도록 제공하기 위한 함수 입니다.
 * 
 * @function createRawApis
 * @memberof InfaceAuthSDK
 * @param {InfaceAuth} instance
 */
 function createRawApis(instance) {
  
  return []
}

export default createRawApis
export { createRawApis }
